import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const MerchantCategoriesRoutes: Routes = [
  {
    path: "merchant-categories",
    loadComponent: () =>
      import("./merchant-categories/merchant-categories.component").then(
        (m) => m.MerchantCategoriesComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./merchant-categories-list/merchant-categories-list.component").then(
            (m) => m.MerchantCategoriesListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./merchant-categories-form/merchant-categories-form.component").then(
            (m) => m.MerchantCategoriesFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./merchant-categories-form/merchant-categories-form.component").then(
            (m) => m.MerchantCategoriesFormComponent,
          ),
      },
    ],
  },
];
